import React from 'react';
import {ButtonBar, SaveButton, DeleteButton, Form, Field} from '../commons/Forms.js';
import ReactSpinner from 'react-spinjs';
import {connect} from 'react-redux';
import {modifyGroomer, deleteGroomer, addGroomer} from '../../redux/groomers/actions';
import {Pane, Part} from '../commons/Panes';
import {PhonePrefix, NEW_ELEMENT_ID} from '../../redux/_commons/const';
import { showPhone } from '../../utils';

/**
 * Panneau d'ajout/édition/suppression de dameuse
 * @class
 */
@connect(
  (state) => ({user: state.user}),
  {modifyGroomer, deleteGroomer, addGroomer}
)
export default class extends React.Component {
  render() {
    const {groomer, inProgress, user} = this.props;

    if (inProgress) {
      return (
        <Pane style={{right: 300}} title="&nbsp;">
          <Part title="Dameuse">
            <ReactSpinner/>
          </Part>
        </Pane>
      );
    }

    return (
      <Pane title="&nbsp;" className="groomer-edition-form">
        <button type="button"
                className="cancel-button"
                onClick={() => this.props.onCancel()}>
          <i className="mi mi-cancel"/>
        </button>
        <EditionForm groomer={groomer} skiresort={user.selectedSkiresort}
                     addGroomer={this.props.addGroomer}
                     modifyGroomer={this.props.modifyGroomer}
                     deleteGroomer={this.props.deleteGroomer}/>
        <GroomerActivity groomer={groomer}/>
      </Pane>
    );
  }
}


/** Formulaire pour une dameuse */
let EditionForm = ({groomer, skiresort, addGroomer, modifyGroomer, deleteGroomer}) => {

  // This is dirty
  let refs = {};

  const onSubmit = e => {
    e.preventDefault();

    let data = Object.assign({}, groomer, {
      id: groomer.id !== -1 ? groomer.id : undefined,
      phone: refs.phone.value(),
      code: refs.code.value(),
      model: refs.model.value(),
      drivers:refs.drivers.value()
    });

    if (groomer.id === NEW_ELEMENT_ID) {
      Object.assign(data, {
        ski_resort_id: skiresort.id
      });
      addGroomer(data);
    } else {
      modifyGroomer(data);
    }

    return false;
  };

  const onDelete = () => {
    if (confirm('Êtes-vous sûr de vouloir supprimer la dameuse ' + groomer.code + ' ? ')) {
      deleteGroomer(groomer.id);
    }
  };

  const prefix = PhonePrefix[skiresort.country] || '??';

  return (
    <Part title="Dameuse">
      <Form onSubmit={e => onSubmit(e)}>
        <Field ofType="phone" label={ 'Téléphone (commence par ' + prefix + ')' } required={true}
               ref={r => refs['phone'] = r} value={groomer.phone != null && showPhone(groomer.phone) || prefix }/>
        <Field ofType="text" label="Identifiant" required={true}
               ref={r => refs['code'] = r} value={groomer.code}/>
        <Field ofType="text" label="Marque & Modèle" required={true}
               ref={r => refs['model'] = r} value={groomer.model}/>
        <Field ofType="textarea" label="Conducteurs" required={false}
               ref={r => refs['drivers'] = r} value={groomer.drivers}/>

        <ButtonBar>
          <SaveButton/>
          { groomer.id !== NEW_ELEMENT_ID ? <DeleteButton onClick={onDelete}/> : null }
        </ButtonBar>
      </Form>
    </Part>
  );
};


/** Informations diverses sur la dameuse */
let GroomerActivity = ({groomer}) => {
  const {messages_count, justifications_count, alerts_count} = groomer;
  const getValue = (count) => !count || count.length === 0 ? 0 : count[0].aggregate;
  return (
    <Part title="Activité">
      <div className="activity">
        <span>Messages</span>
        <span> {getValue(messages_count)} </span>
      </div>
      <div className="activity">
        <span>Justifications</span>
        <span> {getValue(justifications_count)} </span>
      </div>
      <div className="activity">
        <span>Alertes</span>
        <span>{getValue(alerts_count)}</span>
      </div>
    </Part>
  );
};



// WEBPACK FOOTER //
// ./src/components/admin/GroomerEditionForm.js